import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PatientService } from '@services/patient.service';
import { EmergencyDataResolver } from 'src/app/emergency/service/emergency-data.resolver';
import { EmergencyPatientDataSaver } from 'src/app/emergency/service/emergency-patient-data-saver.service';
import { MessagePayload } from 'src/app/shared/models/share/message-payload';

export interface MessageClickedEvent {
  type: 'action';
  payload: MessagePayload;
}

export interface userClickedEvent {
  type: 'action';
  chatUserId: string;
}

@Component({
  selector: 'itl-chat-message-component',
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.scss'],
  providers: [EmergencyDataResolver, EmergencyPatientDataSaver],
})
export class ChatMessageComponent {
  @Input() text: string;
  @Input() messageTime: string;
  @Input() authorName: string;
  @Input() showNames: boolean;
  @Input() changedMemberSid: boolean;
  @Input() colorHex: string;
  @Input() type: 'local' | 'remote';
  @Input() status: string;
  @Input() payload: MessagePayload;
  @Output() messageClicked = new EventEmitter<MessageClickedEvent>();
  @Output() userClicked = new EventEmitter<userClickedEvent>();

  public customStyle: object;
  public isAdvancedMessage: boolean;
  constructor(private _emergencyDataResolver: EmergencyDataResolver, private _patientService: PatientService) {}

  public async actionButtonClicked(): Promise<void> {
    if (this.payload.patient) {
      const downloadedPatient = await this._patientService.find(this.payload.patient._id);
      if (!downloadedPatient) {
        try {
          await this._emergencyDataResolver.downloadPatient(this.payload.patient);
        } catch (error) {
          window.logger.error('Patient download failed.', error);
          return;
        }
      }
    }

    this.messageClicked.emit({
      type: 'action',
      payload: this.payload,
    });
  }

  public userNameClicked() {
    if (this.payload.substituteUser.user._id) {
      this.userClicked.emit({ type: 'action', chatUserId: this.payload.substituteUser.user._id });
    }
  }
}
